export const coerceArray = <T>(a: T): T extends unknown[] ? T : T[] =>
  (Array.isArray(a) ? a : [a]) as T extends unknown[] ? T : T[];
